import React from 'react';
import { Link } from 'react-router-dom';
import defaultAvatar from '../../assets/images/avatar/avatar-default.png';

const ReviewAvatar = (props) => {

    function addDefaultSrc(e) {
        e.target.src = defaultAvatar;
    }

    return (
        <div className="review-comments-avatar">
            <Link to={`/profile/${props.user.slug}/home`}>
                <img 
                    src={props.user.photo} 
                    alt={props.user.first_name} 
                    onError={addDefaultSrc}
                /> 
            </Link>
        </div>
    );
};

export default ReviewAvatar;